import { Component, Input, OnInit } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {FormBuilder} from "@angular/forms";
import { debounceTime } from 'rxjs';
import { Establishment } from '../../../models/Establishment';
import { PersonsService } from '../../../services/persons.service';
import { AuthService } from '../../../services/auth.service';
import { AddAgencyComponent } from './add-agency/add-agency.component';
import { customColumnsAgencyManagement } from '../../../pages/etablissement/mon-etablissement/components/sites-adresses/data/datable.data';
import { DetailsAgencyComponent } from './details-agency/details-agency.component';
import { EstablishmentService } from '../../../services/establishment.service';
@Component({
  selector: 'app-agency-management',
  templateUrl: './agency-management.component.html',
  styleUrl: './agency-management.component.scss'
})
export class AgencyManagementComponent  implements OnInit {

  @Input() establishment: Establishment;
  protected readonly customColumnsAgencyManagement = customColumnsAgencyManagement;

  offset = 0;
  limit = 10;
  loading = false;
  form = this.fb.group({
    agencyId: this.auth.id,
    keyword: [''],
    offset: this.offset,
    limit: this.limit,
  })
  initAgencyList: any[] = [];
  filteredAgencyList: any[] = [];
  totalItems: number
 constructor(private dialog: MatDialog,
             private personService: PersonsService,
             private establishmentService :EstablishmentService ,
             private fb: FormBuilder,
             private auth: AuthService,
             ) {
 }

 ngOnInit() {
   this.consumeGetAgencies();
   this.form.get('keyword')?.valueChanges.pipe(debounceTime(700)).subscribe(value => {
    this.searchAgency(value);
   })
   this.personService.getRefreshData().subscribe({
     next: () => {
       this.consumeGetAgencies()
     }
   })
 }

 handleRowClick = (row: any) => {
  this.dialog.open(DetailsAgencyComponent, {
    width: '666px',
    height: '100vh',
    position: { right: '0' },
    backdropClass: 'bg-transparent',
    data: row,
  });
};

 

 openAddAgencyDialog() {
    const dialogRef =this.dialog.open(AddAgencyComponent, {
      width: '700px',
      autoFocus: false,

    })
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.consumeGetAgencies()
      }
    })
  }

  pagination(event: any) {
    this.form.get('offset')?.patchValue(event.pageIndex)
    this.consumeGetAgencies();
  }

  searchAgency(event: any) {
    const keyword = event.target.value.trim().toLowerCase();
    console.log('keyword', keyword);
    if (keyword) {
      this.filteredAgencyList = this.initAgencyList.filter((agency: any) => {
        return (
          agency.mail?.toLowerCase().includes(keyword) ||
          agency.agencyName?.toLowerCase().includes(keyword) ||
          agency.siret?.toLowerCase().includes(keyword) ||
          agency.address?.toLowerCase().includes(keyword) ||
          agency.agencyResponsable?.toLowerCase().includes(keyword)
        );
      });
    } else {
      this.filteredAgencyList  = [...this.initAgencyList];
    }
  }

  consumeGetAgencies() {
    this.establishmentService.getAgencies().subscribe({
      next: (agencies: any) => {
        if (!!agencies && agencies.length > 0) {
          this.initAgencyList = agencies.map((e: any) => {
            return {
              id: e.id,
              agencyName: e.name,
              address: e.address,
              agencyResponsable: e?.dirigeantPrincipal?.firstName,
              siret: e.siret,
              phone: e.phone,
              mail: e?.email,
              main: e?.main
            };
          });
          this.filteredAgencyList = [...this.initAgencyList];
          this.totalItems = agencies.length;
          this.loading = false;
        }
      }
    });
  }
}
